import { Group } from "@/types/group.interface";
import { Project, ProjectFormData } from "@/types/project.interface";
import { Segment } from "@/types/segment.interface";
import { ReferenceImage } from "@/types/reference-image.interface";

const Api = {
    projects: {
        list: (): Promise<Project[]> => fetch("/api/projects").then(res => res.json()),
        create: (data: ProjectFormData): Promise<Project | { error: string }> =>
            fetch("/api/projects", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) }).then(res => res.json()),
        update: (id: string, data: Partial<Project>): Promise<Project | { error: string }> =>
            fetch(`/api/projects/${id}`, { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) }).then(res => res.json()),
        delete: (id: string): Promise<Response> =>
            fetch(`/api/projects?id=${id}`, { method: "DELETE" }),
    },
    groups: {
        list: (): Promise<Group[]> => fetch("/api/groups").then(res => res.json()),
        get: (id: string): Promise<Group> => fetch(`/api/groups/${id}`).then(res => res.json()),
        create: (data: { name: string; projectId: string | null }): Promise<Group> =>
            fetch("/api/groups", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) }).then(res => res.json()),
        update: (id: string, data: Partial<Group>): Promise<Group> =>
            fetch(`/api/groups/${id}`, { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) }).then(res => res.json()),
        delete: (id: string): Promise<Response> =>
            fetch(`/api/groups/${id}`, { method: "DELETE" }),
        reorder: (orders: { id: string; order: number }[]): Promise<Response> =>
            fetch("/api/groups/reorder", { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ orders }) }),
        download: (key: string): Promise<{ url: string }> =>
            fetch(`/api/groups/download?key=${encodeURIComponent(key)}`).then(res => res.json()),
        clearVideo: (id: string): Promise<Response> =>
            fetch(`/api/groups/${id}/clear-video`, { method: "PATCH" }),
    },
    segments: {
        create: (data: { desc: string; prompt: string; negativePrompt: string; order: number; groupId: string }): Promise<Segment | { error: string }> =>
            fetch("/api/segments", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) }).then(res => res.json()),
        update: (id: number, data: Partial<Segment>): Promise<Response> =>
            fetch(`/api/segments/${id}`, { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) }),
        delete: (id: number): Promise<Response> =>
            fetch(`/api/segments/${id}`, { method: "DELETE" }),
        reorder: (orders: { id: number; order: number }[]): Promise<Response> =>
            fetch("/api/segments/reorder", { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ orders }) }),
        batchUpdate: (segments: { id: number; desc: string; prompt: string; negativePrompt: string }[]): Promise<Response> =>
            fetch("/api/segments/batch", { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ segments }) }),
        sync: (groupId: string, segments: Segment[]): Promise<Segment[]> =>
            fetch(`/api/segments/sync?groupId=${groupId}`, { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ segments }) }).then(res => res.json()),
        clearVideo: (id: number): Promise<Response> =>
            fetch(`/api/segments/${id}/clear-video`, { method: "PATCH" }),
    },
    upload: {
        upload: (formData: FormData): Promise<ReferenceImage & { error?: string }> =>
            fetch("/api/upload", { method: "POST", body: formData }).then(res => res.json()),
        delete: (id: number): Promise<Response> =>
            fetch(`/api/upload?id=${id}`, { method: "DELETE" }),
    },
    referenceImages: {
        delete: (id: number): Promise<Response> =>
            fetch(`/api/upload?id=${id}`, { method: "DELETE" }),
    },
    generate: {
        start: (groupId: string): Promise<Response> =>
            fetch("/api/generate", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ groupId }) }),
    }
}

export default Api